import { Modal } from 'antd';
import { TFunction } from 'i18next';

export interface ProgressStepView {
  nodeId: string;
  label: string;
  statusName: string;
  state: 'done' | 'current' | 'upcoming';
  approvers: { id: string; fullName: string; email: string }[];
  remindAvailableAt: string | null;
  canRemind: boolean;
  approvedAt: string | null;
  approvedBy: { id: string; fullName: string } | null;
}

export interface ProgressView {
  payrollDetailsId: number;
  payrollName: string;
  isCompleted: boolean;
  isCanceled: boolean;
  cooldownMinutes: number;
  steps: ProgressStepView[];
}

/** Popup bắt buộc trước khi nhắc (Excel mục 4: "bạn có chắc chắn muốn gửi lại"). */
export const confirmRemind = (
  t: TFunction,
  progress: ProgressView,
  step: ProgressStepView | undefined,
  onOk: () => void,
) => {
  const steps = step ? [step] : progress.steps.filter((s) => s.state === 'current');
  const approvers = steps
    .flatMap((s) => s.approvers.map((a) => a.fullName || a.email))
    .filter(Boolean)
    .join(', ');
  Modal.confirm({
    title: t('payroll:resend_confirm_title'),
    content: t('payroll:resend_confirm_content', { name: progress.payrollName, approvers }),
    okText: t('action:confirm'),
    cancelText: t('action:cancel'),
    onOk,
  });
};
